import { Mutation } from 'vuex'
import { SocialDistributionState } from '../types'
import { SocialDistributionStatus } from '@/types/socialDistribution'

const setOptions: Mutation<SocialDistributionState> = (state, payload) => {
  state.items.value = state.items.value.map((social) => {
    const enabled = social.published ?? social.enabled
    const activeFrom =
      social.active_from && new Date(social.active_from) < new Date()

    const isPublished =
      social?.status === SocialDistributionStatus.PUBLISHED ||
      (enabled && activeFrom)

    return {
      ...social,
      text: !isPublished ? payload.text || social.text : social.text,
      active_from: !isPublished
        ? payload.active_from ?? social.active_from
        : social.active_from,
      published_now: !isPublished
        ? payload.published_now ?? social.published_now
        : social.published_now,
    }
  })
  state.options.pasteText = payload.text || state.options.pasteText
  state.options.pasteDate = payload.active_from || state.options.pasteDate
  state.options.pastePublishedNow =
    payload.published_now || state.options.pastePublishedNow
}

export default setOptions
